<template lang="pug">
  footer.footer
    .container
      .left
        a.atom75Logo(href="https://atom75.ru/" target="_blank")
          img(src="@/assets/img/footer_logo.png")
        .socials
          a(href="https://vk.com/rosatomru" target="_blank")
            img(src="@/assets/img/socials/vk_footer.png")
          a(href="https://www.facebook.com/rosatom.ru" target="_blank")
            img(src="@/assets/img/socials/facebook_footer.png")
          a(href="https://www.instagram.com/rosatom_ru/" target="_blank")
            img(src="@/assets/img/socials/instagram_footer.png")
      .right
        a.policy(href="https://calendar.atom75.ru/static/files/cookies_ru.pdf" target="_blank") Политика в отношении обработки персональных данных
        //p(v-html="'All materials are accessible by CC&nbsp;BY-NC 3.0 license with obligatory indication &copy; \"Rosatom\" State Atomic Energy Corporation'")
        a.atomLogo(href="https://www.rosatom.ru/" target="_blank")
          img(src="@/assets/img/logo.png")
</template>

<script>
export default {
name: "Footer"
}
</script>

<style scoped lang="scss">
  .footer {
    display: flex;
    justify-content: space-between;
    padding-bottom: 2.6rem;
    background: url(../assets/img/footer_garland.png) no-repeat center top -0.2rem / 100% auto #fff;
    .container {
      display: flex;
      justify-content: space-between;
      padding-top: 4.5rem;
    }
    .left {
      .atom75Logo {
        display: block;
        width: 8rem;
        margin-bottom: 1.1rem;
        img {
          width: 100%;
        }
      }
      .socials {
        display: flex;
        a {
          width: 1.5rem;
          height: 1.5rem;
          margin-right: 0.7rem;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }

    }
    .right {
      display: flex;
      align-items: flex-start;
      .policy {
        margin-right: 6.7rem;
        padding-top: 1rem;
        font-size: 0.875rem;
        font-weight: bold;
        text-decoration: underline;
        color: #878687;
      }
      p {
        max-width: 9.7rem;
        margin-right: 4.5rem;
        padding-top: 0.7rem;
        font-size: 0.65rem;
        line-height: 1.35;
        color: #ccc;
      }
      .atomLogo {
        width: 3.8rem;
        img {
          width: 100%;
        }
      }
    }

    @include mobile_or_P {
      padding-bottom: 1rem;
      background-size: auto 1.38rem;
      .container {
        padding-top: 4.1rem;
      }
      .left {
        .atom75Logo {
          margin-bottom: 1.6rem;
          transform: translateY(-1.2rem);
        }
        .socials {
          padding-left: 0.3rem;
          a {
            margin-right: 0.85rem;
          }
        }
      }
      .right {
        .policy {
          margin-right: 1rem;
          margin-left: 3rem;
          padding-top: 0.5rem;
          font-size: 0.75rem;
          line-height: 1.2;
        }
        p {
          max-width: 5.7rem;
          margin-right: 2.5rem;
          padding-top: 0.3rem;
          font-size: 0.45rem;
        }
        .atomLogo {
          width: 2.55rem;
          flex-shrink: 0;
        }
      }
    }
  }
</style>